// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-toolbar-toolbar-iUvdp {
  height: 34px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/page-toolbar/page-toolbar.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".toolbar {\n  height: 34px;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `page-toolbar-toolbar-iUvdp`
};
export default ___CSS_LOADER_EXPORT___;
